import axios from "axios";
import { setAuthToken } from "./setAuthToken";

export const login = async(email:string, password:string) => {
    const loginPayload = {
        email: email,
        password: password
    }
    const uninterceptedAxiosInstance = axios.create();
    var loginResponse = {token:null, message:''};
    return await uninterceptedAxiosInstance.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/login", loginPayload)
    .then(response => {
        const token  =  response.data.access_token;
        localStorage.setItem("token", token);
        setAuthToken(token);
        loginResponse.token = token;
        return loginResponse;
    })
    .catch(err => {
        loginResponse.token = null;
        loginResponse.message = "Username o password errati"
        return loginResponse;
    });
}

export const logout = async() => {
    return await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/logout")
        .then(response => {
            localStorage.removeItem("user");
            localStorage.removeItem("token");
            return response.data.message;
        })
        .catch(err => {
            return false;
        });
}

export const getProfile = async() => {
    return await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/me")
        .then(response => {
            const user  =  response.data;
            localStorage.setItem("user", JSON.stringify(user));
            return user;
        })
        .catch(err => {
            return false;
        });
}